import * as React from 'react';
import styled from 'styled-components';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ENTER_KEY_CODE } from '@sdk/common/constants';
import Button from '@sdk/components/primitives/Button';
import Row from '@sdk/components/ui/spacing/Row';
import TextField from '@sdk/components/forms/TextField';
import View from '@sdk/components/primitives/View';
import DisplayText from '@sdk/components/ui/DisplayText';

import CloseSvg from '@web/assets/svg/Icons/16/close-gray.svg';

import LinkIconButton from './LinkIconButton';
import { useEditLinkForm } from './editLinkForm.hooks';

const ButtonsContainer = styled(Row)`
  align-items: center;
`;

const SubmitButton = styled(Button)`
  margin-left: 10px;
  margin-right: 10px;
  background-color: transparent;
`;

const UrlContainer = styled(View)`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export type Props = {
  initialUrl: string;
  isVisible: boolean;
  close: () => void;
  dismiss: () => void;
  onSubmit?: () => void;
};

const EditLinkForm = (props: Props) => {
  const { changeValue, isInvalid, submit, urlInputRef } = useEditLinkForm(props);

  const handleOnKeyPress = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.which === ENTER_KEY_CODE && event.shiftKey === false) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <>
      <UrlContainer>
        <TextField
          ref={urlInputRef}
          invalid={isInvalid}
          skipErrorMessage
          placeholder={gettext('Add a link')}
          onChange={changeValue}
          onKeyPress={handleOnKeyPress}
          onFocus={(event): void => {
            event.preventDefault();
            event.nativeEvent.stopImmediatePropagation();
          }}
        />
      </UrlContainer>
      <ButtonsContainer>
        <SubmitButton onClick={submit}>
          <DisplayText fontSize={14} semiBold themeColor={ThemeColorType.primary}>
            {gettext('Save')}
          </DisplayText>
        </SubmitButton>
        <LinkIconButton onClick={(): void => props.dismiss()}>
          <CloseSvg />
        </LinkIconButton>
      </ButtonsContainer>
    </>
  );
};

export default EditLinkForm;
